import { injectStyle } from './style';
export const createTooltip = (buttonMap, utils) => {
    const div = document.createElement('div');
    const style = utils.getStyle(injectStyle) || '';
    if (style) {
        div.classList.add(style);
    }
    div.classList.add('tooltip');
    return {
        dom: div,
        render: (editorView) => {
            var _a;
            Object.values(buttonMap)
                .filter((item) => item.enable(editorView))
                .forEach(({ $ }) => div.appendChild($));
            (_a = editorView.dom.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(div);
        },
    };
};
//# sourceMappingURL=create-tooltip.js.map